import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import './Index.less';
import HwzComponent from '../../common/component/HwzComponent';
import Moon from '../../common/model/global/Moon';
import User from '../../common/model/user/User';
import HwzTitle from '../widget/HwzTitle';
import { Tabs } from 'antd';
import HwzContentCard from '../widget/HwzContentCard';
import Install from '../../common/model/install/Install';
import SelectDeployPanel from './widget/SelectDeployPanel';
import Lang from '../../common/model/global/Lang';

const { TabPane } = Tabs;

interface IProps extends RouteComponentProps {}

interface IState {}

export default class Index extends HwzComponent<IProps, IState> {
  user: User = Moon.getSingleton().user;

  install: Install = new Install();

  //当前高亮的tab
  activeName: string = 'before';

  constructor(props: IProps) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    let that = this;

    that.updateUI();
  }

  render() {
    let that = this;

    let install: Install = this.install;

    return (
      <div className="page-install-index">
        <HwzTitle name={Lang.t('layout.install')}></HwzTitle>

        <HwzContentCard>
          <Tabs
            activeKey={this.activeName}
            onTabClick={(activeKey: string) => {
              this.activeName = activeKey;
              this.updateUI();
            }}
          >
            <TabPane tab={Lang.t('install.selectDeploy')} key="before">
              <SelectDeployPanel   
                install={install}
                onNextStep={() => {
                  // 不再跳转到其他分页
                }}
              />
            </TabPane>
          </Tabs>
        </HwzContentCard>
      </div>
    );
  }
}